import { useState } from 'react'

/**
 * OAuth ログインコンポーネント
 *
 * Googleアカウントでログイン。
 * バックエンドから認証URLを取得してGoogleにリダイレクト。
 */
export function OAuthLogin() {
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleGoogleLogin = async () => {
    setLoading(true)
    setError('')

    try {
      // バックエンドから認証URLを取得
      const res = await fetch('/api/auth/google')

      if (!res.ok) {
        throw new Error('Failed to initialize OAuth')
      }

      const data = await res.json()

      // Googleの認証ページにリダイレクト
      window.location.href = data.auth_url
    } catch (err) {
      console.error('OAuth init error:', err)
      setError('Failed to start login process. Please try again.')
      setLoading(false)
    }
  }

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>CoDMON Image Gallery</h2>
        <p className="login-subtitle">Sign in with your Google account</p>

        <button
          onClick={handleGoogleLogin}
          disabled={loading}
          className="login-button google-login-button"
        >
          {loading ? 'Redirecting...' : 'Sign in with Google'}
        </button>

        {error && <p className="error-message">{error}</p>}
      </div>
    </div>
  )
}
